import { UserLanguageResponseListDto } from '@hello-hola/shared-schema';
import { KyInstance } from 'ky';

export class UserLanguageService {
    constructor(private readonly apiClient: KyInstance) {}

    getUserLanguages = (userId?: number): Promise<UserLanguageResponseListDto> => {
        if (!userId) return Promise.resolve([]);

        return this.apiClient.get(`user/${userId}/languages`).json();
    };
}
